import PropTypes from 'prop-types';
// @mui
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import MaintenanceBanner from 'src/components/maintenance-banner/maintenance-banner';
import Header from '../dashboard/header';
//

// ----------------------------------------------------------------------

export default function CompactLayout({ children }) {
  return (
    <>
      <MaintenanceBanner />
      <Header />

      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}

CompactLayout.propTypes = {
  children: PropTypes.node,
};
